var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"loading-small",attrs:{"src":require("@/assets/img/loading.gif")}})}
var staticRenderFns = []

export { render, staticRenderFns }